//define results object
var push_results = {};
//define the market variable from the url htpps://www.example.com/en-us/quiz => en-us
var url = window.location.href;
var market = url.split('/')[3] + "/";
if (market == "pages/") {
    market = "";
}
console.log("market: "+ market);
// On click of an option update the input value and show the next question
document.querySelectorAll('[data-quiz-value]').forEach(function(el) {
    el.addEventListener('click', function() {
        var question_id = this.parentElement.parentElement.id;
        document.getElementById(question_id + '-input').value = this.getAttribute('data-quiz-value');
        document.getElementById(question_id).classList.add('_hidden');
        //posthog event
        var event_name = 'quiz_step_' + question_id.split('-')[1];
        posthog.capture(event_name, {
            question_id: question_id.split('-')[1],
            answer: this.getAttribute('data-quiz-value')
        });
        if (this.parentElement.parentElement.nextElementSibling) {
            document.getElementById(this.parentElement.parentElement.id).nextElementSibling.classList.remove('_hidden');
        } else {
            quizComplete([
                parseInt(document.getElementById('question-1-input').value),
                parseInt(document.getElementById('question-2-input').value),
                parseInt(document.getElementById('question-3-input').value),
                parseInt(document.getElementById('question-4-input').value)
            ]);
        }
    });
});
// On click of the back button show the previous question
document.querySelectorAll('.back-button').forEach(function(el) {
    el.addEventListener('click', function() {
        document.getElementById(this.parentElement.id).classList.add('_hidden');
        document.getElementById(this.parentElement.id).previousElementSibling.classList.remove('_hidden');
    });
});
// On click of the retake button refresh the page
document.getElementById('retake-quiz-button').addEventListener('click', function() {
    location.reload();
});
// on click of the save results button show the email form
document.getElementById('show-email-form').addEventListener('click', function() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'WkGjwa']);
});
// on click of the skip button show the results
document.getElementById('skip-email').addEventListener('click', function() {
    document.getElementById('email-container').classList.add('_hidden');
    document.getElementById('quiz-results').classList.remove('_hidden');
    document.getElementById('product-results-section-1').classList.remove('_hidden');
});
// on click of the submit button or close button show the results
window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.formId == 'WkGjwa') {
        if (e.detail.type == 'submit') {
            setTimeout(function () {
                klaviyo.push(["track", "Completed Quiz", push_results]);
            }, 5000);
        }
        if(e.detail.type == 'close') {
            document.getElementById('email-container').classList.add('_hidden');
            document.getElementById('quiz-results').classList.remove('_hidden');
            document.getElementById('product-results-section-1').classList.remove('_hidden');
        }
    }
});
function quizComplete(answers) {
    let resultsObj = {
        totals: [],
        handles: [],
        product_ids: []
    };
    //loop through products to calculate total scores
    quiz.products.forEach(function(product) {
        //multiply each answer by the corresponding value in the product array
        var total = 0;
        answers.forEach(function(answer, index) {
            total += parseInt(product.ans[index][answer]);
        });
        //add the special value to the total
        total += parseInt(product.ans[4]);
        resultsObj.totals.push(total);
        resultsObj.handles.push(product.handle);
        resultsObj.product_ids.push(product.product_id);
    });
    //find best products
    max_indices = sortIndices(resultsObj.totals);
    //Find the top 3 products
    var percent_1 = Math.round((resultsObj.totals[max_indices[0]] / 65)*100);
    var percent_2 = Math.round(((resultsObj.totals[max_indices[1]] - 1) / 65)*100);
    var percent_3 = Math.round(((resultsObj.totals[max_indices[2]] - 2) / 65)*100);
    //posthog event
    posthog.capture('quiz_complete', {
        quiz_results: {
            product_1: quiz.products[max_indices[0]].handle,
            product_2: quiz.products[max_indices[1]].handle,
            product_3: quiz.products[max_indices[2]].handle,
            product_1_percent: percent_1,
            product_2_percent: percent_2,
            product_3_percent: percent_3,
            product_1_id: quiz.products[max_indices[0]].product_id,
            product_2_id: quiz.products[max_indices[1]].product_id,
            product_3_id: quiz.products[max_indices[2]].product_id
        }
    });
    //publish shopify event
    Shopify.analytics.publish('quiz_complete',
        {
            product_1: quiz.products[max_indices[0]].handle,
            product_2: quiz.products[max_indices[1]].handle,
            product_3: quiz.products[max_indices[2]].handle,
            product_1_percent: percent_1,
            product_2_percent: percent_2,
            product_3_percent: percent_3,
            product_1_id: quiz.products[max_indices[0]].product_id,
            product_2_id: quiz.products[max_indices[1]].product_id,
            product_3_id: quiz.products[max_indices[2]].product_id
        }
    );
    //setting results object
    push_results = {
        product_1: quiz.products[max_indices[0]].product_id,
        product_2: quiz.products[max_indices[1]].product_id,
        product_3: quiz.products[max_indices[2]].product_id,
        product_1_title: quiz.products[max_indices[0]].product_title,
        product_2_title: quiz.products[max_indices[1]].product_title,
        product_3_title: quiz.products[max_indices[2]].product_title,
        product_1_percent: percent_1,
        product_2_percent: percent_2,
        product_3_percent: percent_3
    };
    //call the section rendering api for each of the top 3 products
    fetch("/" + market + 'products/' + quiz.products[max_indices[0]].handle + '?section_id=quiz-results-section')
        .then(response => response.text())
        .then(data => {
            var element = document.getElementById("product-results-section-1");
            element.innerHTML = data;
            document.getElementById('percent-1').innerHTML = percent_1 + '%';
            // element.classList.remove('_hidden');
            // document.getElementById("quiz-results").classList.remove('_hidden');
            // show email container
            document.getElementById('email-container').classList.remove('_hidden');
        });
    fetch("/" + market + 'products/' + quiz.products[max_indices[1]].handle + '?section_id=quiz-results-section')
        .then(response => response.text())
        .then(data => {
            var element = document.getElementById("product-results-section-2");
            element.innerHTML = data;
            document.getElementById('percent-2').innerHTML = percent_2 + '%';
        });
    fetch("/" + market + 'products/' + quiz.products[max_indices[2]].handle + '?section_id=quiz-results-section')
        .then(response => response.text())
        .then(data => {
            var element = document.getElementById("product-results-section-3");
            element.innerHTML = data;
            document.getElementById('percent-3').innerHTML = percent_3 + '%';
        });
}
function sortIndices(ary) {
    return Array.from(Array(ary.length).keys()).sort((a, b) => ary[b] < ary[a] ? -1 : (ary[a] < ary[b]) | 0);
}
var resultsNavButtons = document.getElementsByClassName('results-nav-button');
Array.from(resultsNavButtons).forEach(function(button) {
    button.addEventListener('click', function() {
        //get id of the result from the id of the clicked element
        var result_id = this.id.split('-')[2];
        //hide all results
        document.getElementById('product-results-section-1').classList.add('_hidden');
        document.getElementById('product-results-section-2').classList.add('_hidden');
        document.getElementById('product-results-section-3').classList.add('_hidden');
        //show the selected result
        document.getElementById('product-results-section-' + result_id).classList.remove('_hidden');
        //remove font-bold from all buttons
        Array.from(resultsNavButtons).forEach(function(button) {
            button.classList.remove('_font-bold');
            button.classList.remove('selected-result');
        });
        //add font-bold to the selected button
        this.classList.add('_font-bold', 'selected-result');
        document.getElementById('percent-' + result_id).classList.add('_font-bold');
    });
});